const SizeChart = require('./sizeChart.js')

function addClassNameListener(elem, callback) {
    // var elem = document.getElementById(elemId);
    var lastClassName = elem.className;
    window.setInterval( function() {   
       var className = elem.className;
        if (className !== lastClassName) {
            callback();   
            lastClassName = className;
        }
    },10);
}

const product = {
    iframe: false,
    buttonDestination: 'cart',
    contents: {
        quantity: true,
        title: false,
        img: false
    },
    text: {
        button: 'add to cart'
    },
    classes: {
        button: "shopify-buy__btn left"
    },
    events: {
        'afterRender': function(comp) {
            SizeChart(comp.node)
        }
    }
}

const option = {
    templates: {
        option: `<div class="{{data.classes.option.option}}" data-element="option.option">
            <label for="{{data.selectId}}" class="{{data.classes.option.label}} {{#data.onlyOption}}{{data.classes.option.hiddenLabel}}{{/data.onlyOption}}" data-element="option.label">{{data.name}}</label>
            <div class="{{data.classes.option.wrapper}}" data-element="option.wrapper">
                <select id="{{data.selectId}}" class="{{data.classes.option.select}}" name="{{data.name}}" data-element="option.select">
                    {{#data.values}}
                        <option {{#selected}}selected{{/selected}} value="{{name}}">{{name}}</option>
                    {{/data.values}}
                </select>
            </div>
            <a href="#" class="sizechart"></a>
        </div>`
    },
}

const cart = {
    iframe: false,
    templates: {
        itemHeader: `<div class="{{data.classes.cart.itemHeader}}">
                    <div>product</div>
                    <div>size</div>
                    <div>quantity</div>
                    <div>price</div>
                </div>`,
        title: `<div class="{{data.classes.cart.header}}" data-element="cart.header">
                <button class="{{data.classes.cart.close}}" data-element="cart.close">
                <span class="{{data.classes.cart.title}}" data-element="cart.title">{{data.text.title}}</span>
                &thinsp;
                <span aria-hidden="true">[&times;]</span>
                <span class="visuallyhidden">{{data.text.closeAccessibilityLabel}}</span>
                </button>
            </div>`,
    },
    contents: {
        title: true,
        discounts: false,
        itemHeader: true
    },
    order: ['title','itemHeader','lineItems','footer'],
    classes: {
        button: "left",
        itemHeader: "shopify-buy__cart-item-header headline"
    },
    text: {
        empty: "no items",
        button: "checkout",
        title: "cart",
        total: "",
        currency: "EUR",
        notice: "tax incl.; shipping excl.",
    },
    events: {
        // updateItemQuantity: function (cart) {
        //     console.log(cart, cart.lineItems)
        // },
        'afterRender': function (cart) {
            const cartEl = $('.shopify-buy-cart-wrapper')
            addClassNameListener(cartEl[0], function() {
                if (cart.isVisible) {
                    $('body').addClass('oncart')
                } else {
                    $('body').removeClass('oncart')
                }
            })
        }
    }
    // DOMEvents: {
    //     'change .shopify-buy-cart-wrapper': function (evt, target) {
    //         console.log(evt)
    //     }
    // }
};

const lineItem = {
    contents: {
        quantityIncrement: true,
        quantityDecrement: true,
        price: false,
        image: false,
        delete: false
    },
    templates: {
        delete: `<div class="delete">&times;</div>`,
        quantity: `<div class="{{data.classes.lineItem.quantity}}" data-element="lineItem.quantity">
                <button class="{{data.classes.lineItem.quantityButton}} {{data.classes.lineItem.quantityDecrement}}" type="button" data-line-item-id="{{data.id}}" data-element="lineItem.quantityDecrement">–</button>
                <input class="{{data.classes.lineItem.quantityInput}}" type="number" min="0" aria-label="{{data.text.quantityInputAccessibilityLabel}}" data-line-item-id="{{data.id}}" value="{{data.quantity}}" data-element="lineItem.quantityInput">
                <button class="{{data.classes.lineItem.quantityButton}} {{data.classes.lineItem.quantityIncrement}}" type="button" data-line-item-id="{{data.id}}" data-element="lineItem.quantityIncrement">+</button>
                </div>`,
    },
    order: ['image','title','variantTitle','quantity','delete','priceWithDiscounts'],
    // DOMEvents: {
    //     'click .delete': function (evt, target) {
    //         console.log(ui)
    //     }
    // }
};
const toggle = {
    iframe: false,
    templates: {
        count: '<span class="{{data.classes.toggle.count}}" data-element="toggle.count">[{{data.count}}]</span>',
        title: '<span class="{{data.classes.toggle.title}}" data-element="toggle.title">{{data.text.title}}</span> ',
    },
    contents: {
        icon: false,
        title: true
    },
    order: ['title','count'],
    text: {
        title: 'cart'
    },
    classes: {
        toggle: 'button'
    }
    // DOMEvents: {
    //     'click .shopify-buy__cart-toggle__title': function (evt, target) {
    //         console.log(evt)
    //     }
    // }
};

// window: {
//     width: 800,
//     height: 800,
//     center: 1,
//     titlebar: 'no'
// }

module.exports = {
    product: product,
    cart: cart,
    lineItem: lineItem,
    toggle: toggle,
    option: option
}